<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { IconInfo } from '@/components/icons'
import { useStore } from '@/stores/store'
import { storeToRefs } from 'pinia'
import { onMounted, ref } from 'vue'

const store = useStore()
const { isButtonMiddle, shape } = storeToRefs(store)
const triangleImgPath = `${store.imgPath}/triangle-with-button0.png`
const circleImgPath = `${store.imgPath}/shapes/circle-with-button.svg`
const trapezoidImgPath = `${store.imgPath}/trapezoid-with-button.svg`
const parallelogramImgPath = `${store.imgPath}/parallelogram-with-button.svg`

const contactUsHref = ref('/')
onMounted(() => {
  if(import.meta.env.PROD && window?.BASE_URL) {
    contactUsHref.value = window.BASE_URL + 'contact'
  }
})
</script>
<template>
  <transition name="modal">
    <div class="modal-mask" v-if="store.isButtons === 'buttons_yes'">
      <div class="fabrics-list-wrapper space-y-6 lg:space-y-10">
        <div class="hidden">
          <img v-if="shape === 'triangle'" class="cushion-img" :src="triangleImgPath" />
          <img v-if="shape === 'circle'" class="cushion-img" :src="circleImgPath" />
          <img v-if="shape === 'trapezoid'" class="cushion-img" :src="trapezoidImgPath" />
          <img v-if="shape === 'parallelogram'" class="cushion-img" :src="parallelogramImgPath" />
        </div>
        <fieldset class="form-padding space-y-2">
          <legend class="topic-position font-semibold text-lg lg:text-xl">
            {{ $t('Do you want a button in the middle?') }}
          </legend>
          <div class="form-part stitches-part flex gap-4">
            <label class="simple-radio" for="button_middle_yes">
              <input
                id="button_middle_yes"
                v-model="isButtonMiddle"
                type="radio"
                class="radio-input"
                value="button_middle_yes"
                name="isButtonMiddle"
                required
              />
              <span class="check-text">{{ $t('Yes') }}</span>
            </label>
            <label class="simple-radio" for="button_middle_no">
              <input
                id="button_middle_no"
                v-model="isButtonMiddle"
                required
                type="radio"
                class="radio-input"
                value="button_middle_no"
                name="isButtonMiddle"
              />
              <span class="check-text">{{ $t('No') }}</span>
            </label>
          </div>
        </fieldset>
        <div
          class="contact-form-link flex flex-col items-start bg-black/80 px-6 py-4 text-white w-full max-w-[480px] space-y-4"
        >
          <div class="flex gap-2 justify-center items-center">
            <IconInfo class="text-white w-6 h-6" />
            <span class="w-full"
              >{{ $t('If you want another arrangement of buttons, please contact us.') }}
            </span>
          </div>
          <a :href="contactUsHref" target="_blank" rel="noopener noreferrer" class="underline hover:text-white">{{ $t('Contact us') }}</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped></style>
